import dayjs from "dayjs";
import { useMemo } from "react";

const setDayStartTime = (date: dayjs.Dayjs) => {
  return date
    .set("hours", 0)
    .set("minutes", 0)
    .set("seconds", 0)
    .set("millisecond", 0);
};

const setDayEndTime = (date: dayjs.Dayjs) => {
  return date
    .set("hours", 23)
    .set("minutes", 59)
    .set("seconds", 59)
    .set("millisecond", 999);
};

// Process dates in local browser time and in last step convert to store
// timezone, just before creating a iso string.
export const useStartEndDates = (
  periodType: string | undefined,
  customStart: string | undefined,
  customEnd: string | undefined,
  timezone: string
) => {
  return useMemo(() => {
    const sevenDaysStart = setDayStartTime(dayjs().subtract(7, "days"))
      .tz(timezone, true)
      .toISOString();
    const endDate = setDayEndTime(dayjs()).tz(timezone, true).toISOString();

    switch (periodType) {
      case "period=4weeks":
        return {
          startDate: setDayStartTime(dayjs().subtract(28, "days"))
            .tz(timezone, true)
            .toISOString(),
          endDate,
        };

      case "period=custom":
        if (customStart && customEnd) {
          return {
            startDate: setDayStartTime(dayjs(customStart))
              .tz(timezone, true)
              .toISOString(),
            endDate: setDayEndTime(dayjs(customEnd))
              .tz(timezone, true)
              .toISOString(),
          };
        } else {
          return { startDate: sevenDaysStart, endDate };
        }

      case "period=7days":
      default:
        return { startDate: sevenDaysStart, endDate };
    }
  }, [customEnd, customStart, periodType, timezone]);
};
